<div [class]="containerClass">
  <div [class]="labelContainerClass">
    <label [for]="formFieldId" [class]="labelClass">{{ label }}</label>
    <i *ngIf="tooltip" class="pi pi-info-circle cursor-pointer" [pTooltip]="tooltip"
       [tooltipStyleClass]="tooltipStyleClass"></i>
  </div>
  <div [class]="contentClass">
    <ng-content></ng-content>
    <small class="p-error" *ngIf="form && controlName && FormUtils.hasFormControlErrors(form, controlName)">
      <span *ngIf="isRequired">This field is required.</span> {{ additionalMessage }}
    </small>
  </div>
</div>
